import React from "react";
import { Dropdown, Nav, NavItem } from 'react-bootstrap';
import GoogleTranslateHandler from "~/shared/GoogleTranslateHandler";
import { getUserEmail, getUserPortalUrl, getUserRole, isUserLoggedIn, logoutUser } from "./auth-utils";
import { Link, useHistory } from 'react-router-dom';
import logoImage from '~/img/logo.svg'
import FormButton from "./form/FormButton";

export default function AppHeader({ pageTitle, showTranslator, navBarContents }) {
    return (
        <div className="flex flex-wrap lg:flex-nowrap flex-col lg:flex-row items-center gap-2 p-2 bg-white drop-shadow-sm shadow-neutral-950 z-1">
            <div className="flex items-center gap-4 justify-center">
                <Link to="/"><img className="h-16" src={logoImage} /></Link>
                <div className="flex flex-col h-fit w-fit">
                    <h1 className="text-3xl! m-0 h-fit w-min xs:w-auto font-normal!">{pageTitle}</h1>
                    {isUserLoggedIn() && <span className="text-muted fs-6">{getUserEmail()}</span>}
                </div>
            </div>
            {(showTranslator || getUserRole() === "FAMILY") && <GoogleTranslateHandler className="ml-2" />}
            <nav className="flex flex-col xs:flex-row h-fit lg:ml-auto whitespace-nowrap gap-3">
                {navBarContents.map(item => <NavBarContent {...item} key={item.text} />)}
                {!navBarContents.some(c => c.dropdown) && isUserLoggedIn() && (
                    <FormButton family={getUserRole() === "FAMILY"} size="text-base" outlined formless linkTo={getUserPortalUrl()} onClick={logoutUser} className="mr-2">
                        Logout
                    </FormButton>
                )}
            </nav>
        </div>
    );
}

function NavBarLink({ as: Component = Nav.Link, link, onClick, children, className = "", ...rest }) {
    const history = useHistory();
    className += " text-base px-3";

    if (rest.disabled) {
        className += " text-neutral-500";
    }

    if (onClick) {
        return <Component {...rest} className={className} href={link} onClick={e => (e.preventDefault(), onClick(history))}>{children}</Component>
    }

    return link.includes("://") ? (
        <Component {...rest} className={className} href={link} target="_blank" rel="noopener noreferrer">{children}</Component>
    ) : (
        <Component {...rest} className={className} href={link} onClick={e => (e.preventDefault(), history.push(link))}>{children}</Component>
    );
}

function NavBarContent({ dropdown, text, link, items }) {
    if (dropdown) {
        return (
            <Dropdown as={NavItem} align="end" className="text-base p-0!">
                <Dropdown.Toggle as={NavBarLink}>{text}</Dropdown.Toggle>
                <Dropdown.Menu className="xs:-translate-x-[35%] min-w-0! gap-2 py-1 overflow-clip z-1000">
                    {items.map(item => (
                        <NavBarLink as={Dropdown.Item} key={item.text} disabled={item.disabled} link={item.link} className="d-flex align-items-center py-1 w-full">
                            {item.text} {item.link.includes("://") && <i className="bi bi-box-arrow-up-right ms-2 fs-6 position-relative bottom-px" />}
                        </NavBarLink>
                    ))}
                    {isUserLoggedIn() && <NavBarLink as={Dropdown.Item} className="d-flex align-items-center py-1 w-full" link={getUserPortalUrl()} onClick={history => history.push(logoutUser())}>Logout</NavBarLink>}
                </Dropdown.Menu>
            </Dropdown>
        );
    }

    return (
        <NavBarLink as={Nav.Link} link={link} className="text-decoration-none">
            <div>{text}</div>
        </NavBarLink>
    );
};
